// extracted by mini-css-extract-plugin
export default {"sidePanelHeader":"webview_sidePanelHeader__GpmFj","webview":"webview_webview__QjM5K"};